import { httpV1 as http } from '@/services/api';

/** Communications center (backoffice). `form` is the same object as the wizard's. */

const BASE = '/backoffice/communications';

export async function listCommunications(params) {
  return http.get(BASE, { params }).then(({ data }) => data);
}

export async function getCommunication(id) {
  return http.get(`${BASE}/${id}`).then(({ data }) => data.data);
}

export async function createCommunication(form) {
  return http.post(BASE, { form }).then(({ data }) => data.data);
}

export async function updateCommunication(id, form) {
  return http.patch(`${BASE}/${id}`, { form }).then(({ data }) => data.data);
}

export async function deleteCommunication(id) {
  return http.delete(`${BASE}/${id}`);
}

/** action: publish | pause | resume | cancel */
export async function changeCommunicationStatus(id, action) {
  return http.post(`${BASE}/${id}/${action}`).then(({ data }) => data.data);
}

/**
 * Response: { success, channel, destination, external_id?, error?, result }.
 * Provider failure (SMS/email) returns HTTP 200 with `success: false` + `error`.
 */
export async function sendCommunicationTest(id, channel, destination) {
  return http.post(`${BASE}/${id}/test`, { channel, destination }).then(({ data }) => data.data);
}

export async function getCpfTimeline(cpf, params) {
  return http.get(`${BASE}/tracking/${cpf}`, { params }).then(({ data }) => data.data);
}

/** Query: from, to (YYYY-MM-DD), channel. */
export async function getCommunicationMetrics(id, params) {
  return http.get(`${BASE}/${id}/metrics`, { params }).then(({ data }) => data.data);
}

/** Version history events (newest first). */
export async function listCommunicationVersions(id) {
  return http.get(`${BASE}/${id}/versions`).then(({ data }) => data.data);
}

/** Version detail, including the `form` saved at that moment. */
export async function getCommunicationVersion(id, version) {
  return http.get(`${BASE}/${id}/versions/${version}`).then(({ data }) => data.data);
}
